// extracted by mini-css-extract-plugin
export default {"wrapper":"wWqX_bKp8q6BfK2x3n_4","title":"QSVVqN8zCgeQLnvUGjQX","section":"dbFhvCM3YfdK8ih0i1rL","formulaHelper":"S6Hpe6XmiLRwMojTUxrt"};